<template>
  <main>
    <div class="koc-view">
      <div
        class="koc-wrapper-component kol-wrapper"
      >
        <div
          v-if="state.sponsors"
          class="koc-sponsor-logos-container"
        >
          <div
            v-for="sponsor in state.sponsors"
            :key="sponsor.id"
            :style="{flexBasis: (100 / state.displayPerRow) + '%' }"
            class="koc-sponsor-logo"
          >
            <a
              :href="sponsor.tracking_url"
              class="koc-sponsor-logo-link"
              target="_blank"
            >
              <img
                :alt="sponsor.name"
                :src="sponsor.logo.full"
                class="koc-sponsor-logo-image"
              >
            </a>
          </div>
        </div>
        <div
          v-if="state.showNotification"
          class="koc-notification koc-full"
        >
          <h3>{{ state.notification }}</h3>
          <div
            class="koc-close"
            @click="clearNotification"
          />
        </div>
      </div>
    </div>
  </main>
</template>

<script src="./kol-sponsor-logos.js"></script>
<style lang="scss" scoped src="./kol-sponsor-logos.scss"></style>
